import { Navigate, useLocation, useParams, useRoutes } from "react-router-dom";

import EditPage from "./edit";
import IndexPage from "./index";

export default () =>
  useRoutes([
    { path: "/search/:search", element: <WithParameters component={IndexPage}/> },
    { path: "/:siteId", element: <WithParameters component={EditPage}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  const loc = useLocation();
  return <Comp {...parameters} location={loc}/>;
}
